import { useEffect } from "react";
import {
  CATEGORY_DISCLOSURES_ES,
  GENERAL_PARTNERSHIP_DISCLOSURE_ES,
  PARTNERSHIP_ANALYTICS_EVENTS,
} from "../../../constants/automapPartnershipConstants";
import { trackPartnershipEvent } from "../../../services/automapPartnershipApi";

export default function PartnerDisclosure({ category, compact = false, onViewed }) {
  const categoryText = CATEGORY_DISCLOSURES_ES[category] || "";

  useEffect(() => {
    trackPartnershipEvent(PARTNERSHIP_ANALYTICS_EVENTS.DISCLOSURE_VIEWED, { category });
    onViewed?.();
  }, [category, onViewed]);

  if (compact) {
    return (
      <p className="partnerships-disclosure">
        {GENERAL_PARTNERSHIP_DISCLOSURE_ES}
        {categoryText ? ` ${categoryText}` : ""}
      </p>
    );
  }

  return (
    <div className="partnerships-disclosure">
      <p>{GENERAL_PARTNERSHIP_DISCLOSURE_ES}</p>
      {categoryText ? <p style={{ marginTop: "0.5rem" }}>{categoryText}</p> : null}
    </div>
  );
}
